import { PostOdataAdsAPIParams, getFullUrlOfAdsOdata, WithEntityPath } from './adsOdata';
import { DateRange } from './listingGroupGridData';
import { Model$ProductAttributeStatistic, Header } from '../ApiType';

interface ProductAttrubuteStatisticsEntityPath {
  productListingGroupId: number;
}

interface ProductAttrubuteStatisticsPayload {
  gridDataParameters: {
    DateRange: DateRange;
  },
  operand: string;
}

export type ProductAttrubuteStatisticsParams = PostOdataAdsAPIParams<ProductAttrubuteStatisticsPayload> & WithEntityPath<ProductAttrubuteStatisticsEntityPath>;

export interface ProductAttrubuteStatisticsResponse {
  value: Model$ProductAttributeStatistic[];
  headers: Header;
}

// when editing tree view, the opened panel is also a grid, use this API to get data.
export function productAttrubuteStatisticsRequest(baseUrl: string, params: ProductAttrubuteStatisticsParams) {
  const path = `ProductListingGroups(${params.entityPath.productListingGroupId})/ProductAttributeStatistics/Default.ProductListingGroupGridData`;
  const finalUrl = getFullUrlOfAdsOdata(baseUrl, path, params);
  return [finalUrl, {
    method: 'POST',
    body: JSON.stringify(params.payload),
  }];
}

export async function productAttrubuteStatisticsResponseHandler(responsePromise: Promise<Response>) {
  const p$response = await responsePromise;
  const response: ProductAttrubuteStatisticsResponse = await p$response.json();
  response.headers = p$response.headers;

  return response;
}
